import type { PackageListModel } from "../features/packages/package/packagesList/interfacePackage";

export type PackageSearchType = "customized" | "fixed";

export type PackageSearchRow = PackageListModel & {
    packageType: PackageSearchType;
};

export type PackageSearchItem = {
    kind: "package";
    id: string;
    label: string;
    subtitle: string;
    url: string;
    icon: string;
    packageId: number;
    packageType: PackageSearchType;
};

function packageHaystack(row: PackageSearchRow): string {
    return [row.id, row.code, row.name, row.regionName, row.sourceCountryName]
        .filter((x) => x !== undefined && x !== null)
        .map((x) => String(x).toLowerCase())
        .join(" ");
}

export function packageListPath(packageType: PackageSearchType, query?: string | number): string {
    const base = `/packages/${packageType}`;
    if (query === undefined || query === null || query === "") return base;
    return `${base}?q=${encodeURIComponent(String(query))}`;
}

export function filterPackageSearchItems(
    packages: PackageSearchRow[],
    query: string,
    limit = 6
): PackageSearchItem[] {
    const q = query.trim().toLowerCase();
    if (!q) return [];

    return packages
        .filter((row) => packageHaystack(row).includes(q))
        .slice(0, limit)
        .map((row) => {
            const typeLabel = row.packageType === "customized" ? "FIT" : "GIT";
            return {
                kind: "package" as const,
                id: `package-${row.packageType}-${row.id}`,
                label: `${row.name || "Untitled"} (${row.code || `#${row.id}`})`,
                subtitle: [typeLabel, row.regionName, row.sourceCountryName, row.id != null ? `ID ${row.id}` : ""]
                    .filter(Boolean)
                    .join(" · "),
                url: packageListPath(row.packageType, row.id),
                icon: "ti-package",
                packageId: Number(row.id),
                packageType: row.packageType,
            };
        });
}
